import  { configArea, defaultCity }  from '@/api/config.js'
export { configArea, defaultCity }
// 默认分页配置
export const configPage = {
  // 默认页码
  pageNo: 1,
  // 默认每页显示数量
  pageSize: 10,
  // 数量切换选项
  pageSizes: [10, 20, 50, 100],
  // 每页显示数量（少）
  pageSizeShort: 5,
  // 数量切换选项（少）
  pageSizesShort: [5, 10, 20, 50],
  // 分页显示内容
  pageLayout: 'total, prev, pager, next, sizes'
}

// 系统名称
export const systemName = `${defaultCity.city}政务地图`
export const orgName = `${defaultCity.city}政务服务`

export const markerIcons = {
  governs: 'ri-government-fill',
  major: 'ri-hotel-fill',
  terminal: 'ri-mac-fill'
}
